import React from 'react';
import { Route } from 'react-router-dom';

import WorldMapCircles from './pages/WorldMapCircles';

const Routes = [<Route exact={true} key="/admin/worldmapcircles" path="/spot/admin/worldmapcircles" component={WorldMapCircles} />];

export default Routes;
